<template>
  <div>
    <div v-if="!isLoading">
      <div class="container" >
        <form @submit.prevent="onSubmit">
          <b-row>
            <div class="col-12">
              <div class="timeline-box h-100">
                <div class="box-title">
                  <i class="fa fa-list" aria-hidden="true"></i>
                  Paiement des prestations {{ order.patients.user.nom }} {{ order.patients.user.prenom }}
                </div>
                <div class="box-content">
                  <div class="box-item column-display-style column-display-style-without-mb">
                    <div class="row">
                      <div class="col-md-6 text-right">
                        <p><strong>{{ $t('message.nomSouscripteur') }}</strong></p>
                      </div>
                      <div class="col-md-6 text-left">
                        <p>{{ order.souscripteur.user.nom }}</p>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-md-6 text-right">
                        <p><strong>{{ $t('message.nomPatient') }}</strong></p>
                      </div>
                      <div class="col-md-6 text-left">
                        <p>{{ order.patients.user.nom }}</p>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-md-6 text-right">
                        <p><strong>{{ $t('message.dateFacturation') }}</strong></p>
                      </div>
                      <div class="col-md-6 text-left">
                        <p>{{ formattedDate(order.date_facturation) }}</p>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-md-6 text-right">
                        <p><strong>{{ $t('message.amount') }}</strong></p>
                      </div>
                      <div class="col-md-6 text-left">
                        <p>{{ order.amount }} FCFA</p>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-md-6 text-right">
                        <p><strong>{{ $t('message.status') }}</strong></p>
                      </div>
                      <div class="col-md-6 text-left">
                        <p>{{ getStatut(order.statut) }}</p>
                      </div>
                    </div>
                    <div class="row" v-if="order.statut == 'PAYE'">
                      <div class="col-md-6 text-right">
                        <p><strong>{{ $tc('message.motifPayment',2) }}</strong></p>
                      </div>
                      <div class="col-md-6 text-left">
                        <p>{{ order.motif }}</p>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="box-footer mt-5">
                  <div class="row">
                    <div class="col-md-6 text-right">
                      <p><strong>{{ $t('message.moyenpaiement') }}</strong></p>
                    </div>
                    <div class="col-md-6 text-left">
                      <div class="cc-selector row">
                        <div class="col-md-4">
                          <input id="orange" type="radio" v-model="moyenpaiement" name="moyenpaiement" value="orange"/>
                          <label class="drinkcard-cc orange" for="orange"></label>
                        </div>
                        <div class="col-md-4">
                          <input id="stripe" type="radio" v-model="moyenpaiement" name="moyenpaiement" value="stripe" />
                          <label class="drinkcard-cc stripe" for="stripe"></label>
                        </div>
                      </div>
                      <small v-if="moyenpaiement==''" id="emailHelp" class="form-text text-danger">{{ error }}</small> 
                    </div>
                  </div>
                  <div class="row" v-if="moyenpaiement!='' && moyenpaiement!='stripe'">
                    <div class="col-md-6 text-right">
                      <p><strong>{{ $t('message.telephone') }} {{moyenpaiement == 'orange' ? 'Orange Money' : 'MTN Mobile Money'}}</strong></p>
                    </div>
                    <div class="col-md-4 text-left">
                      <input type="number" name="telephone" min="650000000" max="699999999" id="telephone" v-model="telephone" class="form-control" v-validate="'required'" :placeholder="moyenpaiement == 'orange' ? '6xxxxxxxx' : '6xxxxxxxx'" :class="errors.has('telephone') ? 'is-invalid' : ''"/>
                      <small id="emailHelp" class="form-text text-danger">{{ errors.has('telephone') ? 'Le numero '+(moyenpaiement == 'orange' ? 'Orange Money' : 'MTN Mobile Money')+' est requis' : "" }}</small> 
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </b-row>
          <b-container class="text-center mt-4">
            <b-row class="justify-content-sm-center">
                <b-button type="submit" variant="danger">
                    {{ $t('message.procederAuPaiement') }}
                </b-button>
            </b-row>
          </b-container>
        </form>
      </div>
    </div>
    <div v-else>
        <loading :active.sync="isLoading" :can-cancel="canCancel" :is-full-page="fullPage" color="#2dcecc" :opacity="opacity"></loading>
    </div>
  </div>
</template>

<script>
window.$ = window.jQuery = window.jquery = require('jquery');
import Vue from 'vue';
import {
    mapGetters
} from "vuex";
import _ from 'lodash';
import Swal from 'sweetalert2';
import moment from "moment";
import AppConfig from "../../constants/AppConfig";
import loading from 'vue-loading-overlay';
import { FadeTransition } from 'vue2-transitions';

export default {
    name: "Paiement",
        components: {
            FadeTransition,
            loading,

        },
    computed: {
      ...mapGetters(["paymentPrestation"]),

      order:function () {
        // console.log(this.paymentPrestation);
         return this.paymentPrestation;
      }
    },

    data() {
        return {
            isLoading:false,
            opacity:0.5,
            canCancel:false,
            fullPage: true,
            moyenpaiement: '',
            telephone: '',
            error: '',
            form: {
                referenceId: '',
                externalId: '',
                numeroTelephone: ''
            },
        }
    },

    methods: {
        getPaymentStatut() {
                let args = {
                   id: this.$route.params.id
                };

                this.$store.dispatch('getPaymentPrestation', { args : args });
        },

        onSubmit() {
                var data = new FormData();
                data.append("moyenpaiement", this.moyenpaiement);
                data.append("telephone", this.telephone);
                data.append("id", this.$route.params.id);
                let self = this;
                if(this.moyenpaiement != ""){
                  this.$validator.validateAll().then((result) => {
                    if (result) 
                    {
                      this.error = "";
                      this.isLoading = true;
                      var stripe = Stripe(AppConfig.stripe_key);

                      fetch(AppConfig.apiUrl + '/payment-prestation', {
                          method: 'POST',
                          headers: {
                              'Content-Type': 'application/json;charset=utf-8'
                          },
                          body: JSON.stringify({
                            id: this.$route.params.id,
                            telephone: this.telephone,
                            moyenpaiement: this.moyenpaiement
                          })
                      })
                      .then(res => res.json())
                      .then(function (session) {
                        if(session.moyenpaiement == "stripe"){
                          return stripe.redirectToCheckout({
                              sessionId: session.id
                          });
                        }else if(session.moyenpaiement == "orange"){
                          if(session.reponse == undefined){
                            Swal.fire(
                                'ERREUR',
                                "Le numéro que vous avez renseigné n'est pas correct. <br/><br/> Le format est le <b>6xxxxxxxx</b>",
                                'error'
                            )
                          }
                          else if (session.reponse.message !=undefined &&  session.reponse.message.includes('successfully')) {
                            let param = {
                              id: self.$route.params.id,
                              pay_token: session.reponse.data.payToken,
                            };
                            self.$router.push({
                              name: "prestation-om-notification",
                              params: param,
                            });
                          }
                          else {
                            if (session.reponse.original!= undefined && session.reponse.original.erreur.includes('Le solde du compte du payeur est insuffisant')) {
                              Swal.fire(
                                "Echec de Paiement!",
                                "Le solde du compte du payeur est insuffisant",
                                "error"
                              );
                            }else if (session.reponse.original!= undefined && session.reponse.original.erreur.includes('Beneficiaire introuvable')) {
                              Swal.fire(
                                "Echec de Paiement!",
                                "Le numéro que vous avez renseigné n'a pas de compte Orange Money. <br/><br/> Veuillez vérifier et reéssayer",
                                "error"
                              );
                            }else{
                              Swal.fire(
                                  'ERREUR',
                                  'Veuillez réessayer plus tard ',
                                  'error')
                            }
                          }
                          self.isLoading = false;
                        }
                          
                      })
                      .then(function (result) {
                          // If `redirectToCheckout` fails due to a browser or network
                          // error, you should display the localized error message to your
                          // customer using `error.message`.
                          if (result.error) {
                              alert(result.error.message);
                          }
                      })
                      .catch(function (error) {
                          console.error('Error:', error);
                      });
                    }
                  });
                }else{
                  this.error = "Sélectionnez un moyen de paiement"
                }
            },

        getStatut(item){
          if ( item == 'PAYE'  ) return 'Facture payée';
          else return 'Facture non payée';
        },
        formattedDate(date) {
           return moment(date).format('DD-MM-YYYY');
        },        
    },
    created() {

    },
    mounted() {
        let ckeditor = document.createElement('script');
        ckeditor.setAttribute('src', "https://js.stripe.com/v3/");
        document.head.appendChild(ckeditor);
        this.getPaymentStatut();
    }
}
</script>

<style scoped>
    @import '~vue-loading-overlay/dist/vue-loading.css';
</style>
